















































































import Vue, { PropType } from "vue";
import InfiniteLoading, { StateChanger } from "vue-infinite-loading";
import { getCompanyDetailRatings, getCompanyDetailReviews } from "@/api";
import {
  ApiResponse,
  CompanyDetailRating,
  CompanyDetailReviewCategory,
  RatingsPoint
} from "@/api/types";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
// TODO: 仕様が固まるまで一旦非表示
// https://github.com/OneCareerJP/cloud/pull/516
//
// import RatingPercentage from "@/components/Pages/CompanyDetail/Molecules/RatingPercentage/index.vue";
import PopoverSelectBox from "@/components/Atoms/Forms/PopoverSelectBox/index.vue";
import ReviewCard from "@/components/Pages/CompanyDetail/Molecules/ReviewCard/index.vue";
import { CompanyDetailRatingShaping } from "../../Molecules/RatingPercentage/types";

interface InfiniteLoadingExpansion extends InfiniteLoading {
  attemptLoad: any;
}

interface Data {
  reviewData: ApiResponse.CompanyDetailReviewData[];
  activeCompareTabIndex: number;
  ratings: CompanyDetailRatingShaping[];
  genre: {
    value: string;
    label: string;
  }[];
  params: {
    ratings: CompanyDetailRatingShaping[];
    genre: string;
  };
}
interface Computed {
  currentCompanyId: string;
}
export interface Props {
  companyId: string;
  reviewDataMaxLength?: number;
  compareCompanies?: (Pick<ApiResponse.CompanyDetail, "id" | "name"> & {
    reviewCount: number;
  })[];
  category: CompanyDetailReviewCategory;
  activeTab: boolean;
  scrollAreaElement?: HTMLElement;
}
interface Methods {
  infiniteHandler: ($state: StateChanger) => void;
  infiniteClear: () => void;
  genreDataSet: () => void;
  getRatings: () => void;
  ratingsShaping: (
    ratings: CompanyDetailRating[]
  ) => CompanyDetailRatingShaping[];
  handleClickCompareTab: (index: number) => void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ReviewContents",
  components: {
    Heading,
    //RatingPercentage,
    PopoverSelectBox,
    ReviewCard,
    InfiniteLoading
  },
  props: {
    companyId: {
      type: String as PropType<Props["companyId"]>,
      required: true
    },
    reviewDataMaxLength: {
      type: Number as PropType<Props["reviewDataMaxLength"]>,
      default: undefined
    },
    compareCompanies: {
      type: Array as PropType<Props["compareCompanies"]>,
      default: undefined
    },
    category: {
      type: String as PropType<Props["category"]>,
      required: true
    },
    activeTab: {
      type: Boolean as PropType<Props["activeTab"]>,
      required: true
    },
    scrollAreaElement: {
      type: HTMLElement as PropType<Props["scrollAreaElement"]>,
      default: undefined
    }
  },
  data() {
    return {
      reviewData: [],
      activeCompareTabIndex: 0,
      ratings: [],
      genre: [],
      params: {
        ratings: [],
        genre: ""
      }
    };
  },
  computed: {
    currentCompanyId() {
      return this.compareCompanies
        ? String(this.compareCompanies[this.activeCompareTabIndex].id)
        : this.companyId;
    }
    // NOTE: レーティングによる絞り込みは非表示
    // reviewDataMaxLength() {
    //   if (this.params.ratings.length) {
    //     return this.params.ratings.reduce((acc, cur) => {
    //       return acc + cur.count;
    //     }, 0);
    //   } else {
    //     return this.ratings.reduce((acc, cur) => {
    //       return acc + cur.count;
    //     }, 0);
    //   }
    // }
  },
  watch: {
    "params.ratings"() {
      this.reviewData = [];
      this.infiniteClear();
    },
    reviewData(newValue, oldValue) {
      if (oldValue && !newValue) this.infiniteClear();
    },
    activeTab(value) {
      if (value && !this.reviewData.length)
        (this.$refs.infiniteLoading as InfiniteLoadingExpansion).attemptLoad();
    }
  },
  created() {
    this.genreDataSet();
    // NOTE: レーティングによる絞り込みは非表示
    // this.getRatings();
  },
  methods: {
    async infiniteHandler($state) {
      this.$nextTick(async () => {
        const res = await getCompanyDetailReviews({
          company_id: this.currentCompanyId,
          category: this.category,
          // NOTE: toFixedがstringを返してしまう
          points: this.params.ratings.map(e => e.point.toFixed(1) as any),
          offset: this.reviewData.length,
          limit: this.reviewData.length + 10
        });
        this.reviewData = this.reviewData.concat(res.data.reviews);

        const isCompleted = this.compareCompanies
          ? this.reviewData.length >=
            this.compareCompanies[this.activeCompareTabIndex].reviewCount
          : !!this.reviewDataMaxLength &&
            this.reviewData.length >= this.reviewDataMaxLength;

        if (isCompleted) {
          $state.complete();
        } else {
          $state.loaded();
        }
      });
    },
    infiniteClear() {
      const infiniteLoading = this.$refs.infiniteLoading as
        | InfiniteLoading
        | undefined;
      infiniteLoading?.stateChanger.reset();
    },
    genreDataSet() {
      switch (this.category) {
        case CompanyDetailReviewCategory.SEMINAR:
          this.genre = [
            {
              value: "rating_ave",
              label: "すべて"
            },
            {
              value: "rating1",
              label: "社風・人の魅力"
            },
            {
              value: "rating2",
              label: "業界・事業の理解度"
            },
            {
              value: "rating3",
              label: "参加学生のレベル"
            },
            {
              value: "rating4",
              label: "採用・選考情報の理解度"
            },
            {
              value: "rating5",
              label: "仕事内容・キャリアの魅力"
            },
            {
              value: "rating6",
              label: "働く環境の魅力"
            }
          ];
          break;
        case CompanyDetailReviewCategory.INTERN:
          this.genre = [
            {
              value: "rating_ave",
              label: "すべて"
            },
            {
              value: "rating1",
              label: "業界・事業の魅力"
            },
            {
              value: "rating2",
              label: "社風・人の魅力"
            },
            {
              value: "rating3",
              label: "自己成長度"
            },
            {
              value: "rating4",
              label: "参加学生のレベル"
            },
            {
              value: "rating5",
              label: "選考の難易度"
            },
            {
              value: "rating6",
              label: "本選考への影響度"
            }
          ];
          break;
        case CompanyDetailReviewCategory.RECRUITMENT:
          this.genre = [
            {
              value: "rating_ave",
              label: "すべて"
            },
            {
              value: "rating1",
              label: "業界・事業の魅力"
            },
            {
              value: "rating2",
              label: "社風・人の魅力"
            },
            {
              value: "rating3",
              label: "仕事内容・キャリアの魅力"
            },
            {
              value: "rating4",
              label: "働く環境の魅力"
            },
            {
              value: "rating5",
              label: "待遇の魅力"
            },
            {
              value: "rating6",
              label: "本選考の難易度"
            }
          ];
          break;
      }
      this.$set(this.params, "genre", this.genre[0].value);
    },
    async getRatings() {
      const res = await getCompanyDetailRatings({
        company_id: this.currentCompanyId,
        category: this.category,
        rating_title: this.params.genre
      });

      this.ratings = this.ratingsShaping(res.data.ratings);
    },
    ratingsShaping(ratings) {
      const total = ratings.reduce((acc, cur) => {
        return acc + cur.count;
      }, 0);

      const baseRatings = [
        {
          point: RatingsPoint["4s"],
          label: "4.0〜5.0"
        },
        {
          point: RatingsPoint["3s"],
          label: "3.0〜4.0未満"
        },
        {
          point: RatingsPoint["2s"],
          label: "2.0〜3.0未満"
        },
        {
          point: RatingsPoint["1s"],
          label: "1.0〜2.0未満"
        }
      ];

      return baseRatings.map(e => {
        let matchIndex = ratings.findIndex(f => {
          return e.point === f.point;
        });
        return {
          point: e.point,
          label: e.label,
          count: ratings[matchIndex].count,
          percent: (ratings[matchIndex].count / total) * 100
        };
      });
    },
    async handleClickCompareTab(index) {
      const $scrollArea = this.scrollAreaElement;
      const $list = this.$refs.list as HTMLElement;

      if ($scrollArea) {
        const listMinHeight = 200;
        const scrollTop =
          $list.offsetTop - $scrollArea.offsetHeight + listMinHeight;
        this.$emit("switchActiveTab", scrollTop);
      }

      this.activeCompareTabIndex = index;
      // NOTE: レーティングによる絞り込みは非表示
      // await this.getRatings();
      this.infiniteClear();
      this.reviewData = [];
    }
  }
});
